import { useState} from 'react'
import CloseIcon from '../../../assets/icons/close.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const ChargerCompModal = ({ onClose, demandResource }) => {
  
  return (
    <div className="detail-modal-background">
      <div className="detail-modal-container">
        {/* HEADER */}
        <div className="detail-modal-header">
          <h3>충전기 간 비교분석</h3>
          <button className='close-btn' onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        {/* CONTENT */}
        <div className="detail-modal-content p-16">
          <div className='flex flex-row mb-20'>
            <div className='flex-1 flex justify-center align-center gap-5 px-10'>
              <p className='charger-comp-charger-title left text-b2-400 text-base'>충전기 A</p>
              <input type="text" className='input-primary flex-1' placeholder='충전기 번호를 입력하세요.'/>
            </div>
            <div className='w-quarter'>
              <button className='btn big-btn btn-primary w-full'>
                변경하기
              </button>
            </div>
            <div className='flex-1 flex justify-center align-center gap-5 px-10'>
              <p className='charger-comp-charger-title right text-b2-400 text-base'>충전기 B</p>
              <input type="text" className='input-primary flex-1' placeholder='충전기 번호를 입력하세요.'/>
            </div>
          </div>
          {/* TABLE */}
          <table className="gray-double-table">
            <tr>
              <td>제주 EV 충전기 01</td>
              <th className='w-quarter'>충전기 번호</th>
              <td>제주 EV 충전기 02</td>
            </tr>
            <tr>
              <td>EVO-1000-01</td>
              <th>고유 식별자</th>
              <td>EVO-1000-02</td>
            </tr>
            <tr>
              <td>100</td>
              <th>용량(kWh)</th>
              <td>100</td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  )
}

export default ChargerCompModal